import { Injectable, signal, computed } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { CustomHttpResponse } from '../model/custom-http-response';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  host = environment.apiUrl;

  private profileSignal = signal<any | null>(null);
  readonly profile = this.profileSignal.asReadonly();

  constructor(private http: HttpClient) {}

  getProfile(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/customer/profile`,
      { observe: 'response' }
    ).pipe(
      tap(response => {
        if (response.body?.data) {
          this.profileSignal.set(response.body.data);
        }
      })
    );
  }

  loadProfileIfNotLoaded(): void {
    if (!this.profileSignal()) {
      this.getProfile().subscribe();
    }
  }

  updateProfile(body: any): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.patch<CustomHttpResponse>(`${this.host}/v1/customer/profile`, body, { observe: 'response' }).pipe(
      tap(() => this.getProfile().subscribe())
    );
  }

  updatePassword(body: any): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.patch<CustomHttpResponse>(`${this.host}/v1/customer/profile/password`, body, { observe: 'response' });
  }

  getAddress(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(`${this.host}/v1/customer/addresses`, { observe: 'response' });
  }

  updateAddress(addressId: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.patch<CustomHttpResponse>(`${this.host}/v1/customer/addresses/${addressId}/default`, '', { observe: 'response' });
  }

  getOrders(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(`${this.host}/v1/customer/orders`, { observe: 'response' });
  }

  getLoyaltyPoints(page?: number, size?: number): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    params = params.append('page', page?.toString() || '0');
    params = params.append('size', size?.toString() || '10');
    return this.http.get<CustomHttpResponse>(`${this.host}/v1/customer/profile/loyalty-points/history`, {
      observe: 'response',
      params
    });
  }
}
